import React from 'react';

import { RoundedTabs } from './styles';

interface Props {
  label: string | JSX.Element;
  isActive: boolean;
  testId: string;
  onClick: () => void;
}
const Tab = ({ label, isActive, testId, onClick }: Props) => (
  <RoundedTabs $active={isActive} data-testid={testId} onClick={onClick}>
    {label}
  </RoundedTabs>
);
export default Tab;
